import axios from 'axios'
import { initializeApp, getApps } from 'firebase/app'
import { getMessaging, getToken, onMessage, isSupported } from 'firebase/messaging'
import store from '../index'
import vm from '~/main'

const setTokenSentToServer = (currentToken) => {
  if (currentToken) {
    localStorage.setItem('sentFirebaseMessagingToken', currentToken)
  } else {
    localStorage.removeItem('sentFirebaseMessagingToken')
  }
}

const isTokenSentToServer = function (currentToken) {
  return localStorage.getItem('sentFirebaseMessagingToken') === currentToken
}

export default {
  namespaced: true,
  actions: {
    onFirebaseAddToken({ rootState }, token) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/online/firebase/token',
          data: { token },
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onFirebaseDeleteToken({ rootState }, token) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/online/firebase/token',
          data: { token },
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    async onFirebaseInit({ rootState, dispatch }, { login }) {
      const firebaseConfig = {
        apiKey: 'AIzaSyBhqweoCc7WEP8Wp0mB4mbLyhTkP9oYKgQ',
        authDomain: 'proapp-b506b.firebaseapp.com',
        projectId: 'proapp-b506b',
        storageBucket: 'proapp-b506b.appspot.com',
        messagingSenderId: '181733555578',
        appId: '1:181733555578:web:c81b273bc48e9bf743aac3',
        measurementId: 'G-TS4F5S4VTP',
      }
      if (getApps().length === 0) {
        initializeApp(firebaseConfig)
      }
      // const supported = await isSupported()
      // console.log('Notification' in window && isSupported())
      if (navigator && navigator.serviceWorker) {
        const messaging = getMessaging()
        try {
          getToken(messaging, {
            vapidKey:
              'BGBFtGeJBNQb_CCvOxxaxEqVbnz8aApnD-xkbvGVSG0OVFzi7itaKidsko1CP1W6_wp-TjPn81ktOpjVWRdiO90',
          })
            .then((currentToken) => {
              if (currentToken) {
                if (store.getters['auth/isLoggedIn']) {
                  if (login) {
                    dispatch('onCheckTokenUse', currentToken)
                  } else {
                    dispatch('sendTokenToServer', currentToken)
                  }
                } else {
                  dispatch('deleteCurentToken')
                }
              } else {
                console.warn('Failed to get token.')
              }
            })
            .catch((err) => {
              console.log('An error occurred while retrieving token. ', err)
              setTokenSentToServer(false)
            })
        } catch (e) {
          console.log(e)
        }
        onMessage(messaging, (payload) => {
          console.log('onMessage', payload)
          const notificationTitle = payload.data.title
          const notificationOptions = {
            body: payload.data.body,
            icon: rootState.companiesConfig.logo.png,
          }
          if (vm.$route.name === 'chatById' ? vm.$route.params.id !== payload.data.chatId : true) {
            let notification = new Notification(notificationTitle, notificationOptions)
            notification.onclick = function (event) {
              event.preventDefault() // prevent the browser from focusing the Notification's tab
              const pushParams =
                payload.data.notification_type === 'chat_message'
                  ? { name: 'chatById', params: { id: payload.data.chatId } }
                  : { name: 'Home' }
              vm.$router.push(pushParams)
            }
          }
          if (store.getters['auth/isLoggedIn'] && !payload.data.chatId) {
            store.dispatch('notificationUser/onNotificationUserGrid', {})
          }
        })
      }
    },
    sendTokenToServer({ dispatch }, currentToken) {
      if (!isTokenSentToServer(currentToken) && store.getters['auth/isLoggedIn']) {
        dispatch('onFirebaseAddToken', currentToken).then((data) => {
          setTokenSentToServer(currentToken)
        })
      }
    },
    async deleteCurentToken({ dispatch }) {
      let currentSaveToken = localStorage.getItem('sentFirebaseMessagingToken')
      if (currentSaveToken) {
        dispatch('onFirebaseDeleteToken', currentSaveToken).then((data) => {
          setTokenSentToServer(false)
        })
      }
    },
    async onCheckTokenUse({ dispatch }, currentToken) {
      await dispatch('deleteCurentToken')
      dispatch('sendTokenToServer', currentToken)
    },
  },
}
